import { useState } from 'react'
import { apiPost } from '../lib/api.js'

async function sendContact(body) {
  return apiPost('/contact/', body)
}

function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', message: '' })
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState(null)
  const [sending, setSending] = useState(false)

  const handleChange = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!form.name.trim() || !form.message.trim()) return
    setSending(true)
    setError(null)
    try {
      await sendContact(form)
      setSubmitted(true)
      setForm({ name: '', email: '', message: '' })
    } catch (err) {
      setError(err.message)
    } finally {
      setSending(false)
    }
  }

  return (
    <div className="pg-layout">
      <div>
        <p className="font-mono text-[11px] uppercase tracking-[0.6px] text-soft-faint mb-3">
          Contact · direct line
        </p>
        <h1 className="text-[36px] sm:text-[48px] md:text-[56px] font-normal leading-[1.02] tracking-[-1.8px] mb-4">
          Contact
        </h1>
        <p className="text-[18px] leading-[1.5] text-soft-dim mb-10">
          This form goes directly to Mugunth via email. The AI agent may also
          auto-detect hire or collaboration intent from your message.
        </p>

        {submitted ? (
          <div className="py-8 border-t border-soft-rule">
            <p className="text-base text-soft-ink font-medium mb-1">Message sent.</p>
            <p className="text-[15px] leading-[1.55] text-soft-dim">
              Mugunth will reply as soon as he can :).
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="name" className="block text-sm text-soft-dim mb-2">Name</label>
              <input
                id="name"
                name="name"
                type="text"
                value={form.name}
                onChange={handleChange}
                required
                className="w-full px-0 py-2 bg-transparent border-0 border-b border-soft-rule text-soft-ink text-base outline-none focus-visible:ring-0 focus-visible:shadow-none transition-colors"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm text-soft-dim mb-2">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                className="w-full px-0 py-2 bg-transparent border-0 border-b border-soft-rule text-soft-ink text-base outline-none focus-visible:ring-0 focus-visible:shadow-none transition-colors"
              />
            </div>

            <div>
              <label htmlFor="message" className="block text-sm text-soft-dim mb-2">Message</label>
              <textarea
                id="message"
                name="message"
                value={form.message}
                onChange={handleChange}
                required
                rows={5}
                className="w-full px-0 py-2 bg-transparent border-0 border-b border-soft-rule text-soft-ink text-base outline-none focus-visible:ring-0 focus-visible:shadow-none transition-colors resize-none"
              />
            </div>

            {error && <p className="text-sm text-red-600">{error}</p>}

            <button
              type="submit"
              disabled={sending}
              className="px-[18px] py-[11px] bg-soft-ink text-soft-bg text-sm cursor-pointer hover:opacity-90 transition-opacity disabled:opacity-50"
            >
              {sending ? 'Sending…' : 'Send message'}
            </button>
          </form>
        )}

        {/* Elsewhere */}
        <div className="mt-12 pt-6 border-t border-soft-rule">
          <p className="font-mono text-[10.5px] uppercase tracking-[0.6px] text-soft-faint mb-4">
            Elsewhere
          </p>
          <div className="flex flex-col gap-4">
            <a
              href="https://github.com/tabspacecoder"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[15px] text-soft-ink border-b border-soft-rule pb-2 hover:text-soft-dim transition-colors"
            >
              GitHub
            </a>
            <a
              href="https://linkedin.com/in/mugunthjc"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[15px] text-soft-ink border-b border-soft-rule pb-2 hover:text-soft-dim transition-colors"
            >
              LinkedIn
            </a>
            <a
              href="mailto:mugunth@example.com"
              className="text-[15px] text-soft-ink border-b border-soft-rule pb-2 hover:text-soft-dim transition-colors"
            >
              Email
            </a>
          </div>
        </div>
      </div>

      {/* Right side is empty for Contact - pg-layout gives it space but no rail content */}
      <aside />
    </div>
  )
}

export default ContactPage
